import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useLang } from "../lib/providers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthConfirmPage() {
  const [params] = useSearchParams();
  const { lang } = useLang();
  const [state, setState] = useState({ loading: true, ok: false, reason: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ loading: false, ok: false, reason: "missing_token" }); return; }
    axios.get(`${API}/customer/confirm`, { params: { token }, withCredentials: true })
      .then((r) => setState({ loading: false, ...r.data }))
      .catch(() => setState({ loading: false, ok: false, reason: "error" }));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-black">
      <div className="max-w-md w-full text-center border border-white/10 p-8 bg-black/60" dir={lang === "ar" ? "rtl" : "ltr"}>
        {state.loading ? (
          <>
            <Loader2 className="w-10 h-10 text-neon mx-auto animate-spin mb-4" />
            <p className="text-white/70">{lang === "ar" ? "جارٍ التأكيد..." : "Confirmation en cours..."}</p>
          </>
        ) : state.ok ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-neon mx-auto mb-4" />
            <h1 className="text-2xl font-black uppercase tracking-tight mb-2" data-testid="auth-confirm-success">
              {lang === "ar" ? "✅ تم تأكيد حسابك" : "✅ Compte confirmé !"}
            </h1>
            <p className="text-sm text-white/70 mb-2">
              {lang === "ar" ? "أنت متصل الآن. مرحبا بك في DZ Tennis Shop !" : "Vous êtes connecté. Bienvenue chez DZ Tennis Shop !"}
            </p>
            <Link to="/mon-compte" className="inline-block mt-6 px-6 py-3 bg-neon text-black font-black uppercase tracking-widest text-sm hover:opacity-90">
              {lang === "ar" ? "حسابي" : "Mon compte"}
            </Link>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 text-clay mx-auto mb-4" />
            <h1 className="text-2xl font-black uppercase tracking-tight mb-2" data-testid="auth-confirm-error">
              {lang === "ar" ? "❌ تعذر التأكيد" : "❌ Confirmation impossible"}
            </h1>
            <p className="text-sm text-white/70">
              {state.reason === "expired"
                ? (lang === "ar" ? "انتهت صلاحية الرابط (24 ساعة). يرجى التسجيل مرة أخرى." : "Le lien a expiré (24h). Veuillez vous réinscrire ou demander un nouveau lien.")
                : (lang === "ar" ? "رابط غير صالح." : "Lien invalide ou déjà utilisé.")}
            </p>
            <Link to="/" className="inline-block mt-6 px-6 py-3 bg-neon text-black font-black uppercase tracking-widest text-sm hover:opacity-90">
              {lang === "ar" ? "العودة إلى المتجر" : "Retour à la boutique"}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
